import { render, staticRenderFns } from "./CourseAdd.vue?vue&type=template&id=0e52d704&"
import script from "./CourseAdd.vue?vue&type=script&lang=js&"
export * from "./CourseAdd.vue?vue&type=script&lang=js&"
import style0 from "./CourseAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports